import { createAxiosInstance } from './createAxiosInstance'

/** The My Cases service behind My Tasks v4.5 (`FeatureFlag.MY_CASES_V4_5`). */
export const myTasksRequest = createAxiosInstance({
  baseURL: import.meta.env.VITE_MY_CASES_BASE_URL,
})

export default myTasksRequest
